import styled from 'styled-components';

export const TaskCardContainer = styled.div`
	background-color: ${({ theme }) => theme.palette.secondary.white};
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	min-width: 350px;
`;

export const ImgContainer = styled.div`
	background-color: ${({ theme }) => theme.palette.secondary['100']};
	border-radius: 8px 8px 0 0;
	height: 255px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		max-height: 100%;
		max-width: 85%;
	}
`;

export const ContentContainer = styled.div`
	height: 255px;
	padding: 24px;
	background-color: ${({ theme }) => theme.palette.secondary.white};
	border-radius: 0 0 8px 8px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const StatusContent = styled.div<{ status: string }>`
	background-color: ${({ theme, status }) =>
		status === 'NOT_AVALIATED' ? theme.palette.secondary['100'] : theme.palette.risk.low['100']};
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	height: 32px;
	margin-bottom: 16px;
	padding: 4px 8px;
	width: fit-content;

	p {
		color: ${({ theme, status }) =>
			status === 'NOT_AVALIATED' ? theme.palette.secondary['400'] : theme.colors.text};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		font-weight: ${({ theme }) => theme.sizes.weights.regular};
		margin: 0;
	}
`;

export const TaskContent = styled.div`
	h4 {
		color: ${({ theme }) => theme.palette.secondary['400']};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
		margin-bottom: 16px;
	}
`;

export const VideoContainer = styled.div`
	width: 100%;
	height: 255px;
	overflow: hidden;
	border-radius: 8px 8px 0 0;
	background-color: black;

	video {
		object-fit: contain;
		width: 100%;
		height: 100%;
	}

	@media (min-width: 1600px) {
		height: 255px;
	}
`;
